<template>
    <div class="input-group">
        <input type="number" v-model="syncValue" id="amount" class="text-field label-xl" :placeholder="this.placeholderText">
        <button @click="onClickEvent" class="send-amount-button" :disabled="this.disabled">
            <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.57568 1.57576C7.80999 1.34145 8.18989 1.34145 8.42421 1.57576L14.0909 7.24243C14.3252 7.47674 14.3252 7.85664 14.0909 8.09096C13.8566 8.32527 13.4767 8.32527 13.2423 8.09096L8.59994 3.44855V14C8.59994 14.3314 8.33131 14.6 7.99994 14.6C7.66857 14.6 7.39994 14.3314 7.39994 14V3.44855L2.75754 8.09096C2.52323 8.32527 2.14333 8.32527 1.90901 8.09096C1.6747 7.85664 1.6747 7.47674 1.90901 7.24243L7.57568 1.57576Z" />
            </svg>
        </button>
    </div>
</template>

<style scoped>
.input-group {
    display: flex;
    gap: 16px;
    align-items: center;
    border-radius: var(--border-radius-m);
    border: 1px solid var(--border-1);
    background: var(--background-2);
    padding: 8px 16px;
    width: 100%;
    height: 48px;
}

.input-group:hover {
    border: 1px solid var(--semantic-highlight-hover);
}

.text-field {
    width: 100%;
    color: var(--content-1);
    caret-color: var(--border-focus);
    text-decoration: none;
    background: none;
    border: none;
    outline: none;
    appearance: textfield;
    -moz-appearance: textfield;
}

.text-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.text-field::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.text-field:focus {
    color: var(--content-1);
}

.send-amount-button {
    width: 32px;
    height: 32px;
    border-radius: 100%;
    background-color: var(--background-3);
    color: var(--content-3-pair);
    border: none;
    cursor: pointer;
    line-height: 0;
}

.send-amount-button svg {
    fill: var(--content-3-pair);

}

.send-amount-button:hover {
    background-color: var(--semantic-highlight-hover);
    color: var(--content-focus);
}

.send-amount-button:hover svg {
    fill: var(--content-focus);
}

.input-error {
    color: var(--semantic-danger);
}
</style>

<script>
export default {
    name: 'InputNumberFieldComponent',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        onClickEvent: {
            type: Function,
            default: () => {}
        },
        placeholderText: {
            type: String,
            default: 'Amount'
        },
        value: {
            type: [Number, String],
            default: 0
        }
    },
    computed: {
        syncValue: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("update:value", newValue);
            }
        }
    }
};
</script>